/**
 * @generated SignedSource<<9ca3fc665c37454b9980885cb1607b02>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type headerAllMenuSectionAppConfigQuery$data = {
  readonly appConfig: {
    readonly json: unknown | null;
  } | null;
  readonly " $fragmentType": "headerAllMenuSectionAppConfigQuery";
};
export type headerAllMenuSectionAppConfigQuery$key = {
  readonly " $data"?: headerAllMenuSectionAppConfigQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"headerAllMenuSectionAppConfigQuery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "headerAllMenuSectionAppConfigQuery",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "entityId": "scmp_pwa_oneline_menu"
          }
        }
      ],
      "concreteType": "AppConfig",
      "kind": "LinkedField",
      "name": "appConfig",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "json",
          "storageKey": null
        }
      ],
      "storageKey": "appConfig(filter:{\"entityId\":\"scmp_pwa_oneline_menu\"})"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "bde2fbd9824b0b9fb7235c55a0e4a64d";

export default node;
